var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgShariatModern = function SvgShariatModern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shariat-modern_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm2.7 3 .74 2.28h2.399l-1.94 1.41.74 2.28L11.7 7.56 9.76 8.97l.741-2.28-1.94-1.41h2.398L11.7 3Zm-4.334.226A5.995 5.995 0 0 0 3 9.001a6 6 0 0 0 11.775 1.633 5.4 5.4 0 0 1-7.41-7.407Z",
    fill: "#31CC7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shariat-modern_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgShariatModern);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBjbGlwLXBhdGg9InVybCgjYSkiPgogICAgICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgICAgICBkPSJNOSAwYTkgOSAwIDEgMCAwIDE4QTkgOSAwIDAgMCA5IDBabTIuNyAzIC43NCAyLjI4aDIuMzk5bC0xLjk0IDEuNDEuNzQgMi4yOEwxMS43IDcuNTYgOS43NiA4Ljk3bC43NDEtMi4yOC0xLjk0LTEuNDFoMi4zOThMMTEuNyAzWm0tNC4zMzQuMjI2QTUuOTk1IDUuOTk1IDAgMCAwIDMgOS4wMDFhNiA2IDAgMCAwIDExLjc3NSAxLjYzMyA1LjQgNS40IDAgMCAxLTcuNDEtNy40MDdaIgogICAgICAgICAgICBmaWxsPSIjMzFDQzdFIiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJhIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGgxOHYxOEgweiIgLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4=";